// extracted by mini-css-extract-plugin
module.exports = {"exitButton":"messages__exitButton___boyE8","messagesWrapper":"messages__messagesWrapper___LQH8S","header":"messages__header___2zP4W","messages":"messages__messages___UWTqm"};